import { backgroundOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const ItineraryPageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;

    #board-column-container {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
`

export const LoadingContainer = styled.div`
	padding: 2rem;
	text-align: center;
`

export const ErrorContainer = styled.div`
	padding: 2rem;
	text-align: center;
	color: red;
`

export const ConnectionStatusContainer = styled.div<{ $isConnected: boolean }>`
	padding: 0.5rem 1rem;
	background: ${props => (props.$isConnected ? '#d4edda' : '#f8d7da')};
	color: ${props => (props.$isConnected ? '#155724' : '#721c24')};
	border-radius: 4px;
	margin-bottom: 1rem;
	font-size: 0.875rem;
	display: flex;
	align-items: center;
	gap: 0.5rem;
`

export const ConnectionStatusDot = styled.div<{ $isConnected: boolean }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${props => (props.$isConnected ? '#28a745' : '#dc3545')};
`

export const TripTitleContainer = styled.div`
	padding: 1rem;
	background: #f8f9fa;
	border-radius: 8px;
	margin-bottom: 1rem;
	text-align: center;
`

export const TripTitle = styled.h3`
	margin: 0 0 0.5rem 0;
	color: #495057;
`

export const EmptyStateContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: calc(100vh - 200px);
	padding: 2rem;
`

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	text-align: center;
`

export const EmptyStateIcon = styled.div`
	color: #000000;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const EmptyStateText = styled.p`
	font-size: 1.125rem;
	color: #495057;
	margin: 0;
	max-width: 400px;
	line-height: 1.6;
`

export const EmptyStateButton = styled.button`
	background: ${orange};
	color: white;
	border: none;
	padding: 0.75rem 1.5rem;
	border-radius: 8px;
	font-size: 1rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active {
		opacity: 0.85;
		transform: translateY(0);
	}
`
